/* eslint-disable func-names */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { getTKT1FileUploadByID, updateTKT1FileUpload } from '../actions';
import { Container, Row, Col, Card, Badge, Button, Table } from "react-bootstrap";
import { FaArrowLeft, FaCopy, FaDownload, FaCode, FaSearchPlus, FaSearchMinus, FaUndo, FaExpand, FaEdit, FaSave, FaTimes } from 'react-icons/fa';
import { toast } from 'react-toastify';
import LoadingSpinner from "../components/LoadingSpinner/LoadingSpinner";

class TKT1SvgDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      svgContent: '',
      normalizedSvgContent: '',
      zoomLevel: 4, // Default zoom level
      showSource: 'normalized', // Default to normalized SVG
      encodedPoints: [], // Array of decoded color-encoded points
      isEditingOriginal: false, // Edit mode for original SVG
      editedOriginalContent: '', // Edited content for original SVG
      saving: false // Saving state
    };
  }

  componentDidMount() {
    const { match } = this.props;
    const svgId = match?.params?.svgId;
    
    if (svgId) {
      this.loadSvgData(svgId);
    } else {
      toast.error('Không tìm thấy SVG ID');
      this.setState({ loading: false });
    }
  }

  loadSvgData = async (svgId) => {
    this.setState({ loading: true });
    
    try {
      await this.props.getTKT1FileUploadByID(svgId);
    } catch (error) {
      console.error('Error loading SVG data:', error);
      toast.error('Lỗi khi tải thông tin SVG. Vui lòng thử lại.');
      this.setState({ loading: false });
    }
  }

  componentDidUpdate(prevProps) {
    // Check if route parameter changed
    const prevSvgId = prevProps.match?.params?.svgId;
    const currentSvgId = this.props.match?.params?.svgId;
    
    if (prevSvgId !== currentSvgId && currentSvgId) {
      this.loadSvgData(currentSvgId);
      return;
    }
    
    // Load SVG content when file upload data is loaded
    if (prevProps.currentFileUpload !== this.props.currentFileUpload) {
      const fileUpload = this.props.currentFileUpload;
      
      if (fileUpload) {
        let svgContent = '';
        let normalizedSvgContent = '';
        
        // Try to get source_svg from metadata (base64)
        if (fileUpload.metadata?.source_svg) {
          try {
            svgContent = atob(fileUpload.metadata.source_svg);
          } catch (err) {
            console.error('Error decoding source_svg:', err);
            svgContent = '-- Lỗi decode source_svg --';
          }
        }
        
        // Get normalizedSvgSource from metadata (base64)
        if (fileUpload.metadata?.normalizedSvgSource) {
          try {
            normalizedSvgContent = atob(fileUpload.metadata.normalizedSvgSource);
          } catch (err) {
            console.error('Error decoding normalizedSvgSource:', err);
            normalizedSvgContent = '-- Lỗi decode normalizedSvgSource --';
          }
        }
        
        // Set default showSource based on available content
        let defaultShowSource = 'normalized';
        if (!normalizedSvgContent && svgContent) {
          defaultShowSource = 'original';
        }
        
        // Parse encoded points from SVG
        const encodedPoints = this.parseEncodedPoints(normalizedSvgContent || svgContent);
        
        this.setState({
          loading: false,
          svgContent,
          normalizedSvgContent,
          showSource: defaultShowSource,
          encodedPoints
        });
        
        // Update document title
        const currentSvgId = this.props.match?.params?.svgId;
        document.title = `SVG Detail - ${fileUpload.filename || fileUpload.original_filename || currentSvgId}`;
      } else {
        this.setState({ loading: false });
      }
    }
  }

  getFileUrl = (s3Key, isPublic = false) => {
    if (!s3Key) return '';
    const bucketName = isPublic ? 'tkt1-public-images' : 'tkt1-images';
    const baseUrl = `https://${bucketName}.s3.ap-southeast-2.amazonaws.com`;
    return `${baseUrl}/${s3Key}`;
  }

  copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      toast.success('Đã sao chép vào clipboard!');
    }).catch(err => {
      console.error('Failed to copy: ', err);
      toast.error('Lỗi khi sao chép');
    });
  }

  handleSaveOriginalSvg = async () => {
    const { currentFileUpload } = this.props;
    const { editedOriginalContent } = this.state;
    
    if (!currentFileUpload || !currentFileUpload._id) {
      toast.error('Không tìm thấy thông tin SVG để cập nhật');
      return;
    }

    if (!editedOriginalContent || !editedOriginalContent.trim()) {
      toast.error('SVG source không được để trống');
      return;
    }

    // Validate SVG format (basic check)
    if (!editedOriginalContent.trim().startsWith('<svg')) {
      if (!window.confirm('Nội dung không bắt đầu bằng <svg. Bạn có chắc chắn muốn lưu?')) {
        return;
      }
    }

    try {
      this.setState({ saving: true });

      // Encode SVG content to base64
      const base64Content = btoa(unescape(encodeURIComponent(editedOriginalContent)));

      // Prepare metadata with updated source_svg
      const updatedMetadata = {
        ...(currentFileUpload.metadata || {}),
        source_svg: base64Content
      };

      // Prepare update data
      const updateData = {
        metadata: updatedMetadata
      };

      // Call update action
      await this.props.updateTKT1FileUpload(currentFileUpload._id, updateData);
      
      // Update local state
      this.setState({
        svgContent: editedOriginalContent,
        isEditingOriginal: false,
        editedOriginalContent: '',
        saving: false
      });

      // Re-parse encoded points
      const encodedPoints = this.parseEncodedPoints(editedOriginalContent);
      this.setState({ encodedPoints });

      toast.success('Đã lưu SVG source thành công!');
      
      // Reload file upload to get updated data
      await this.loadSvgData(currentFileUpload._id);
    } catch (error) {
      console.error('Error saving SVG source:', error);
      toast.error('Lỗi khi lưu SVG source. Vui lòng thử lại.');
      this.setState({ saving: false });
    }
  }

  formatFileSize = (bytes) => {
    if (!bytes) return '-';
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    if (bytes === 0) return '0 Bytes';
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return Math.round(bytes / Math.pow(1024, i) * 100) / 100 + ' ' + sizes[i];
  }

  handleZoomIn = () => {
    this.setState(prevState => ({
      zoomLevel: Math.min(prevState.zoomLevel + 0.25, 10) // Max zoom 10x (1000%)
    }));
  }

  handleZoomOut = () => {
    this.setState(prevState => ({
      zoomLevel: Math.max(prevState.zoomLevel - 0.25, 0.25) // Min zoom 0.25x
    }));
  }

  handleResetZoom = () => {
    this.setState({ zoomLevel: 1 });
  }

  handleZoomToFit = () => {
    // Reset to fit view
    this.setState({ zoomLevel: 1 });
  }

  parseEncodedPoints = (svgContent) => {
    if (!svgContent || (!svgContent.includes('EE') && !svgContent.includes('11AA'))) {
      return [];
    }

    const points = [];
    
    try {
      // Create a temporary DOM element to parse SVG
      const parser = new DOMParser();
      const svgDoc = parser.parseFromString(svgContent, 'image/svg+xml');
      
      // Extract style definitions
      const styles = {};
      const styleElements = svgDoc.querySelectorAll('style');
      styleElements.forEach(style => {
        const cssText = style.textContent || '';
        // Parse CSS rules like .fil0 {fill:#EE0101} or {fill:#11AA01}
        // Match both EE01XX and 11AAXX patterns
        const colorMatches = cssText.matchAll(/\.(\w+)\s*\{[^}]*fill:\s*#((?:EE\d{4})|(?:11AA\d{2}))/g);
        for (const match of colorMatches) {
          styles[match[1]] = match[2]; // class name -> color
        }
      });

      // Find all circles
      const circles = svgDoc.querySelectorAll('circle');
      circles.forEach(circle => {
        const cx = parseFloat(circle.getAttribute('cx'));
        const cy = parseFloat(circle.getAttribute('cy'));
        const classAttr = circle.getAttribute('class');
        
        if (isNaN(cx) || isNaN(cy)) return;
        
        let colorCode = null;
        
        // Try to get color from class
        if (classAttr && styles[classAttr.trim()]) {
          colorCode = styles[classAttr.trim()];
        } else {
          // Try to get color from style attribute
          const styleAttr = circle.getAttribute('style');
          if (styleAttr) {
            // Match both EE01XX and 11AAXX patterns
            const fillMatch = styleAttr.match(/fill:\s*#((?:EE\d{4})|(?:11AA\d{2}))/);
            if (fillMatch) {
              colorCode = fillMatch[1];
            }
          }
        }
        
        if (colorCode) {
          let typeName = 'Unknown';
          let typeCode = '';
          let idCode = '';
          
          if (colorCode.startsWith('EE01')) {
            // Snap Point: EE01XX (6 characters)
            typeName = 'Snap Point';
            typeCode = 'EE01';
            idCode = colorCode.substring(4, 6); // Last 2 digits
          } else if (colorCode.startsWith('11AA')) {
            // Center Point: 11AAXX (6 characters)
            typeName = 'Center Point';
            typeCode = '11AA';
            idCode = colorCode.substring(4, 6); // Last 2 digits
          } else if (colorCode.startsWith('EE')) {
            // Legacy format: EE[type:2digits][id:2digits]
            const legacyTypeCode = colorCode.substring(2, 4);
            idCode = colorCode.substring(4, 6);
            typeCode = `EE${legacyTypeCode}`;
            if (legacyTypeCode === '01') {
              typeName = 'Snap Point';
            } else if (legacyTypeCode === '02') {
              typeName = 'Text Center';
            }
          }
          
          if (typeName !== 'Unknown') {
            points.push({
              type: typeName,
              typeCode: typeCode,
              id: idCode,
              x: cx,
              y: cy,
              color: `#${colorCode}`
            });
          }
        }
      });
      
      // Sort by type, then by ID
      points.sort((a, b) => {
        if (a.typeCode !== b.typeCode) {
          return a.typeCode.localeCompare(b.typeCode);
        }
        return a.id.localeCompare(b.id);
      });
      
    } catch (error) {
      console.error('Error parsing encoded points:', error);
    }
    
    return points;
  }

  render() {
    const { currentFileUpload } = this.props;
    const { loading, svgContent, normalizedSvgContent, zoomLevel } = this.state;
    
    if (loading) {
      return (
        <Container fluid className="py-5">
          <LoadingSpinner text="Đang tải thông tin SVG..." size="lg" />
        </Container>
      );
    }
    
    if (!currentFileUpload) {
      return (
        <Container fluid className="py-5">
          <Card>
            <Card.Body className="text-center">
              <h5 className="text-danger">Không tìm thấy SVG</h5>
              <p className="text-muted">SVG không tồn tại hoặc đã bị xóa.</p>
              <Link to="/admin/rnd/ornament/object">
                <Button variant="primary">
                  <FaArrowLeft className="me-2" />
                  Quay lại danh sách SVG
                </Button>
              </Link>
            </Card.Body>
          </Card>
        </Container>
      );
    }
    
    const isSvg = currentFileUpload.mime_type === 'image/svg+xml' || 
                  currentFileUpload.original_filename?.toLowerCase().endsWith('.svg');
    
    if (!isSvg) {
      return (
        <Container fluid className="py-5">
          <Card>
            <Card.Body className="text-center">
              <h5 className="text-warning">File không phải SVG</h5>
              <p className="text-muted">File này không phải định dạng SVG.</p>
              <Link to="/admin/rnd/ornament/object">
                <Button variant="primary">
                  <FaArrowLeft className="me-2" />
                  Quay lại danh sách SVG
                </Button>
              </Link>
            </Card.Body>
          </Card>
        </Container>
      );
    }

    return (
      <Container fluid className="py-4">
        {/* Header */}
        <Row className="mb-4">
          <Col>
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center gap-3">
                <Link to="/admin/rnd/ornament/object">
                  <Button variant="outline-secondary">
                    <FaArrowLeft className="me-2" />
                    Quay lại
                  </Button>
                </Link>
                <h3 className="mb-0">
                  SVG Detail: {currentFileUpload.filename || currentFileUpload.original_filename}
                </h3>
              </div>
              <div>
                <Button
                  variant="outline-primary"
                  onClick={() => window.open(this.getFileUrl(currentFileUpload.s3_key, currentFileUpload.is_public), '_blank')}
                  className="me-2"
                >
                  <FaDownload className="me-2" />
                  Mở file gốc
                </Button>
              </div>
            </div>
          </Col>
        </Row>

        <Row>
          {/* Left Column - SVG Preview */}
          <Col lg={8}>
            <Card className="mb-4">
              <Card.Header className="d-flex justify-content-between align-items-center">
                <h5 className="mb-0">SVG Preview (Normalized)</h5>
                <div className="d-flex align-items-center gap-2">
                  <span className="text-muted small me-2">Zoom: {Math.round(zoomLevel * 100)}%</span>
                  <Button
                    variant="outline-secondary"
                    size="sm"
                    onClick={this.handleZoomOut}
                    disabled={zoomLevel <= 0.25}
                    title="Zoom Out"
                  >
                    <FaSearchMinus />
                  </Button>
                  <Button
                    variant="outline-secondary"
                    size="sm"
                    onClick={this.handleResetZoom}
                    title="Reset Zoom"
                  >
                    <FaUndo />
                  </Button>
                  <Button
                    variant="outline-secondary"
                    size="sm"
                    onClick={this.handleZoomIn}
                    disabled={zoomLevel >= 10}
                    title="Zoom In"
                  >
                    <FaSearchPlus />
                  </Button>
                </div>
              </Card.Header>
              <Card.Body>
                {normalizedSvgContent ? (
                  <div 
                    className="text-center p-4" 
                    style={{ 
                      backgroundColor: '#f8f9fa', 
                      minHeight: '400px', 
                      display: 'flex', 
                      alignItems: 'center', 
                      justifyContent: 'center',
                      overflow: 'auto'
                    }}
                  >
                    <div
                      dangerouslySetInnerHTML={{ __html: normalizedSvgContent }}
                      style={{ 
                        maxWidth: '100%', 
                        maxHeight: '600px',
                        display: 'inline-block',
                        transform: `scale(${zoomLevel})`,
                        transformOrigin: 'center center',
                        transition: 'transform 0.2s ease-in-out'
                      }}
                    />
                  </div>
                ) : (
                  <div className="text-center p-5">
                    <p className="text-muted">Không có normalized SVG source</p>
                    {svgContent && (
                      <div className="mt-3">
                        <p className="text-muted small">Hiển thị source SVG gốc:</p>
                        <div 
                          dangerouslySetInnerHTML={{ __html: svgContent }}
                          style={{ 
                            maxWidth: '100%', 
                            maxHeight: '400px',
                            display: 'inline-block'
                          }}
                        />
                      </div>
                    )}
                    {!svgContent && currentFileUpload.s3_key && (
                      <img 
                        src={this.getFileUrl(currentFileUpload.s3_key, currentFileUpload.is_public)} 
                        alt={currentFileUpload.original_filename}
                        style={{ maxWidth: '100%', maxHeight: '400px' }}
                        onError={(e) => {
                          e.target.style.display = 'none';
                        }}
                      />
                    )}
                  </div>
                )}
              </Card.Body>
            </Card>

            {/* SVG Source Code */}
            <Card className="mb-4">
              <Card.Header className="d-flex justify-content-between align-items-center">
                <h5 className="mb-0">SVG Source Code</h5>
                <div className="d-flex gap-2">
                  {!this.state.isEditingOriginal && normalizedSvgContent && (
                    <Button
                      variant="outline-secondary"
                      size="sm"
                      onClick={() => this.copyToClipboard(normalizedSvgContent)}
                    >
                      <FaCopy className="me-1" />
                      Copy Normalized SVG
                    </Button>
                  )}
                  {!this.state.isEditingOriginal && svgContent && (
                    <Button
                      variant="outline-secondary"
                      size="sm"
                      onClick={() => this.copyToClipboard(svgContent)}
                    >
                      <FaCopy className="me-1" />
                      Copy Original SVG
                    </Button>
                  )}
                  {this.state.showSource === 'original' && svgContent && !this.state.isEditingOriginal && (
                    <Button
                      variant="outline-primary"
                      size="sm"
                      onClick={() => this.setState({ 
                        isEditingOriginal: true, 
                        editedOriginalContent: svgContent 
                      })}
                    >
                      <FaEdit className="me-1" />
                      Edit Original SVG
                    </Button>
                  )}
                </div>
              </Card.Header>
              <Card.Body>
                <div className="mb-3">
                  <div className="btn-group mb-2" role="group">
                    <Button
                      variant={this.state.showSource === 'normalized' ? "primary" : "outline-primary"}
                      size="sm"
                      onClick={() => {
                        this.setState({ 
                          showSource: 'normalized',
                          isEditingOriginal: false 
                        });
                      }}
                      disabled={!normalizedSvgContent || this.state.isEditingOriginal}
                    >
                      Normalized SVG
                    </Button>
                    <Button
                      variant={this.state.showSource === 'original' ? "primary" : "outline-primary"}
                      size="sm"
                      onClick={() => this.setState({ 
                        showSource: 'original',
                        isEditingOriginal: false 
                      })}
                      disabled={!svgContent}
                    >
                      Original SVG
                    </Button>
                  </div>
                </div>
                
                {this.state.isEditingOriginal && this.state.showSource === 'original' ? (
                  <div>
                    <div className="mb-2 d-flex justify-content-end gap-2">
                      <Button
                        variant="success"
                        size="sm"
                        onClick={this.handleSaveOriginalSvg}
                        disabled={this.state.saving}
                      >
                        <FaSave className="me-1" />
                        {this.state.saving ? 'Đang lưu...' : 'Lưu'}
                      </Button>
                      <Button
                        variant="secondary"
                        size="sm"
                        onClick={() => this.setState({ 
                          isEditingOriginal: false, 
                          editedOriginalContent: '' 
                        })}
                        disabled={this.state.saving}
                      >
                        <FaTimes className="me-1" />
                        Hủy
                      </Button>
                    </div>
                    <textarea
                      value={this.state.editedOriginalContent}
                      onChange={(e) => this.setState({ editedOriginalContent: e.target.value })}
                      style={{
                        width: '100%',
                        minHeight: '400px',
                        fontFamily: 'monospace',
                        fontSize: '12px',
                        padding: '15px',
                        borderRadius: '4px',
                        border: '1px solid #dee2e6',
                        backgroundColor: '#ffffff',
                        resize: 'vertical'
                      }}
                      spellCheck={false}
                    />
                  </div>
                ) : (
                  <pre
                    style={{
                      backgroundColor: '#f8f9fa',
                      padding: '15px',
                      borderRadius: '4px',
                      maxHeight: '500px',
                      overflow: 'auto',
                      fontSize: '12px',
                      border: '1px solid #dee2e6'
                    }}
                  >
                    {(this.state.showSource === 'original' && svgContent) || normalizedSvgContent || svgContent || 'No SVG source available'}
                  </pre>
                )}
              </Card.Body>
            </Card>
          </Col>

          {/* Right Column - File Information */}
          <Col lg={4}>
            {/* Encoded Points Table */}
            {this.state.encodedPoints && this.state.encodedPoints.length > 0 && (
              <Card className="mb-4">
                <Card.Header>
                  <h5 className="mb-0">Color Encoded Points</h5>
                </Card.Header>
                <Card.Body>
                  <div className="table-responsive">
                    <Table striped bordered hover size="sm">
                      <thead>
                        <tr>
                          <th>Type</th>
                          <th>ID</th>
                          <th>X (cx)</th>
                          <th>Y (cy)</th>
                          <th>Color</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.encodedPoints.map((point, index) => (
                          <tr key={index}>
                            <td>
                              <Badge bg={point.typeCode === '01' ? 'primary' : 'info'}>
                                {point.type}
                              </Badge>
                            </td>
                            <td>{point.id}</td>
                            <td>{point.x.toFixed(2)}</td>
                            <td>{point.y.toFixed(2)}</td>
                            <td>
                              <div className="d-flex align-items-center gap-2">
                                <div
                                  style={{
                                    width: '20px',
                                    height: '20px',
                                    backgroundColor: point.color,
                                    border: '1px solid #dee2e6',
                                    borderRadius: '3px'
                                  }}
                                />
                                <span>{point.color}</span>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                  <div className="mt-2 small text-muted">
                    <strong>Quy ước mã hóa:</strong>
                    <br />
                    <strong>Snap Point:</strong> <code>#EE01XX</code> (XX là ID, 2 chữ số)
                    <br />
                    <strong>Center Point:</strong> <code>#11AAXX</code> (XX là ID, 2 chữ số)
                  </div>
                </Card.Body>
              </Card>
            )}

            {/* Metadata */}
            {currentFileUpload.metadata && (
              <Card className="mb-4">
                <Card.Header>
                  <h5 className="mb-0">Metadata</h5>
                </Card.Header>
                <Card.Body>
                  <pre
                    style={{
                      backgroundColor: '#f8f9fa',
                      padding: '10px',
                      borderRadius: '4px',
                      fontSize: '11px',
                      maxHeight: '300px',
                      overflow: 'auto',
                      border: '1px solid #dee2e6'
                    }}
                  >
                    {JSON.stringify(currentFileUpload.metadata, null, 2)}
                  </pre>
                  <Button
                    variant="outline-secondary"
                    size="sm"
                    className="mt-2"
                    onClick={() => this.copyToClipboard(JSON.stringify(currentFileUpload.metadata, null, 2))}
                  >
                    <FaCopy className="me-1" />
                    Copy Metadata
                  </Button>
                </Card.Body>
              </Card>
            )}

            {/* Thông tin File */}
            <Card className="mb-4">
              <Card.Header>
                <h5 className="mb-0">Thông tin File</h5>
              </Card.Header>
              <Card.Body>
                <Row className="mb-2">
                  <Col xs={5}>
                    <strong>Filename:</strong>
                  </Col>
                  <Col xs={7}>
                    <span>{currentFileUpload.filename || currentFileUpload.original_filename}</span>
                    <FaCopy 
                      size={12} 
                      className="ms-2"
                      style={{ cursor: 'pointer', color: '#6c757d' }}
                      onClick={() => this.copyToClipboard(currentFileUpload.filename || currentFileUpload.original_filename)}
                      title="Copy filename"
                    />
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col xs={5}>
                    <strong>Original Filename:</strong>
                  </Col>
                  <Col xs={7}>
                    <span>{currentFileUpload.original_filename}</span>
                    <FaCopy 
                      size={12} 
                      className="ms-2"
                      style={{ cursor: 'pointer', color: '#6c757d' }}
                      onClick={() => this.copyToClipboard(currentFileUpload.original_filename)}
                      title="Copy original filename"
                    />
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col xs={5}>
                    <strong>File Size:</strong>
                  </Col>
                  <Col xs={7}>
                    {this.formatFileSize(currentFileUpload.file_size)}
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col xs={5}>
                    <strong>MIME Type:</strong>
                  </Col>
                  <Col xs={7}>
                    <Badge bg="info">{currentFileUpload.mime_type}</Badge>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col xs={5}>
                    <strong>Status:</strong>
                  </Col>
                  <Col xs={7}>
                    <Badge 
                      bg={
                        currentFileUpload.status === 'UPLOADED' ? 'success' :
                        currentFileUpload.status === 'UPLOADING' ? 'warning' :
                        currentFileUpload.status === 'PROCESSING' ? 'info' :
                        currentFileUpload.status === 'PROCESSED' ? 'primary' :
                        currentFileUpload.status === 'FAILED' ? 'danger' :
                        'secondary'
                      }
                    >
                      {currentFileUpload.status}
                    </Badge>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col xs={5}>
                    <strong>Is Public:</strong>
                  </Col>
                  <Col xs={7}>
                    <Badge bg={currentFileUpload.is_public ? 'success' : 'secondary'}>
                      {currentFileUpload.is_public ? 'Public' : 'Private'}
                    </Badge>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col xs={5}>
                    <strong>Username:</strong>
                  </Col>
                  <Col xs={7}>
                    <Badge bg="info">{currentFileUpload.username || '-'}</Badge>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col xs={5}>
                    <strong>Upload Date:</strong>
                  </Col>
                  <Col xs={7}>
                    {currentFileUpload.upload_date ? 
                      new Date(currentFileUpload.upload_date).toLocaleString('vi-VN') : 
                      '-'
                    }
                  </Col>
                </Row>
                {currentFileUpload.metadata?.belong_to_albums && (
                  <Row className="mb-2">
                    <Col xs={5}>
                      <strong>Belongs to Album:</strong>
                    </Col>
                    <Col xs={7}>
                      <Link to={`/admin/tkt1-media/album-detail/${currentFileUpload.metadata.belong_to_albums}`}>
                        <Badge bg="primary">{currentFileUpload.metadata.belong_to_albums}</Badge>
                      </Link>
                    </Col>
                  </Row>
                )}
                <Row className="mb-2">
                  <Col xs={5}>
                    <strong>S3 Key:</strong>
                  </Col>
                  <Col xs={7}>
                    <small style={{ wordBreak: 'break-all' }}>
                      {currentFileUpload.s3_key}
                    </small>
                    <FaCopy 
                      size={12} 
                      className="ms-2"
                      style={{ cursor: 'pointer', color: '#6c757d' }}
                      onClick={() => this.copyToClipboard(currentFileUpload.s3_key)}
                      title="Copy S3 Key"
                    />
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col xs={5}>
                    <strong>File URL:</strong>
                  </Col>
                  <Col xs={7}>
                    <small 
                      className="text-primary" 
                      style={{ wordBreak: 'break-all', cursor: 'pointer' }}
                      onClick={() => window.open(this.getFileUrl(currentFileUpload.s3_key, currentFileUpload.is_public), '_blank')}
                      title="Click to open"
                    >
                      {this.getFileUrl(currentFileUpload.s3_key, currentFileUpload.is_public).substring(0, 50)}...
                    </small>
                    <FaCopy 
                      size={12} 
                      className="ms-2"
                      style={{ cursor: 'pointer', color: '#6c757d' }}
                      onClick={() => this.copyToClipboard(this.getFileUrl(currentFileUpload.s3_key, currentFileUpload.is_public))}
                      title="Copy URL"
                    />
                  </Col>
                </Row>
              </Card.Body>
            </Card>

            {/* ViewBox Info */}
            {currentFileUpload.metadata?.originalViewBox && (
              <Card className="mb-4">
                <Card.Header>
                  <h5 className="mb-0">Original ViewBox</h5>
                </Card.Header>
                <Card.Body>
                  <Row className="mb-2">
                    <Col xs={5}>
                      <strong>X:</strong>
                    </Col>
                    <Col xs={7}>{currentFileUpload.metadata.originalViewBox.x}</Col>
                  </Row>
                  <Row className="mb-2">
                    <Col xs={5}>
                      <strong>Y:</strong>
                    </Col>
                    <Col xs={7}>{currentFileUpload.metadata.originalViewBox.y}</Col>
                  </Row>
                  <Row className="mb-2">
                    <Col xs={5}>
                      <strong>Width:</strong>
                    </Col>
                    <Col xs={7}>{currentFileUpload.metadata.originalViewBox.w}</Col>
                  </Row>
                  <Row className="mb-2">
                    <Col xs={5}>
                      <strong>Height:</strong>
                    </Col>
                    <Col xs={7}>{currentFileUpload.metadata.originalViewBox.h}</Col>
                  </Row>
                </Card.Body>
              </Card>
            )}
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentFileUpload: state.tkt1FileUploadManagementReducer.currentFileUpload
  };
};

export default connect(mapStateToProps, { getTKT1FileUploadByID, updateTKT1FileUpload })(TKT1SvgDetail);

